<template>
    <textarea
        :name="name"
        :value="val"
        :id="'form_' + name"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        class="form-input"
        :class="[{'uk-form-danger': errors.length}, width]"
        :rows="rows"
    >
    </textarea>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            val: {
                required: false,
                Type: String,
                default: ''
            },
            name: {
                required: true,
                Type: String
            },
            placeholder: {
                required: false,
                Type: String
            },
            label: {
                required: true,
                Type: String
            },
            rows: {
                required: false,
                Type: String,
                default: '5'
            },
            width: {
                required: false,
                type: String,
                default: 'w-full'
            }
        },

        mounted() {
            if(this.val) {
                this.$emit('input', this.val)
            }
        }
    }
</script>